import { Box, Container, Grid, Stack, Typography } from '@mui/material';
import { STEPS } from './constants';

const HowItWorks = () => {
	return (
		<Box
			component="section"
			sx={{
				py: { xs: 7, md: 10 },
				bgcolor: 'background.paper',
				borderTop: '1px solid',
				borderBottom: '1px solid',
				borderColor: 'divider',
			}}
		>
			<Container maxWidth="lg">
				<Box sx={{ textAlign: 'center', mb: { xs: 5, md: 6 } }}>
					<Typography
						variant="overline"
						color="warning.main"
						sx={{ fontWeight: 700, letterSpacing: '0.14em' }}
					>
						Workflow
					</Typography>
					<Typography
						variant="h4"
						component="h2"
						sx={{ mt: 1, fontWeight: 700 }}
					>
						From estimate to paid invoice
					</Typography>
					<Typography
						variant="body1"
						color="text.secondary"
						sx={{ mt: 2, maxWidth: 560, mx: 'auto', lineHeight: 1.8 }}
					>
						You send it once. Bidzbase follows up. They accept in the email.
						You collect the deposit and invoice the rest.
					</Typography>
				</Box>

				<Grid container spacing={4}>
					{STEPS.map((item) => (
						<Grid key={item.step} size={{ xs: 12, md: 4 }}>
							<Stack
								spacing={1.5}
								sx={{ textAlign: { xs: 'center', md: 'left' } }}
							>
								<Typography
									variant="h3"
									sx={{
										fontWeight: 800,
										color: 'primary.main',
										opacity: 0.2,
										lineHeight: 1,
									}}
								>
									{item.step}
								</Typography>
								<Typography variant="h6" sx={{ fontWeight: 700 }}>
									{item.title}
								</Typography>
								<Typography
									variant="body2"
									color="text.secondary"
									sx={{ lineHeight: 1.75 }}
								>
									{item.description}
								</Typography>
							</Stack>
						</Grid>
					))}
				</Grid>
			</Container>
		</Box>
	);
};

export default HowItWorks;
